import { useState } from "react";
import { I_Alert, I_Layers } from "../components/icons";
import { Spinner } from "../components/ui";
import { btnP, glassDeep, heading, input, label } from "../styles.js";
import { URL_CLEAN, sb } from "../supabase.js";

const AuthScreen = () => {
    const [mode, setMode] = useState("signin");
    const [email, setEmail] = useState(""),
      [pw, setPw] = useState(""),
      [name, setName] = useState("");
    const [busy, setBusy] = useState(false),
      [msg, setMsg] = useState(null),
      [err, setErr] = useState(null);
    const submit = async () => {
      setErr(null);
      setMsg(null);
      setBusy(true);
      try {
        if (mode === "signin") {
          const { error } = await sb.auth.signInWithPassword({
            email: email.trim(),
            password: pw,
          });
          if (error) throw error;
        } else {
          const { data, error } = await sb.auth.signUp({
            email: email.trim(),
            password: pw,
            options: {
              data: {
                full_name: name.trim(),
              },
            },
          });
          if (error) throw error;
          if (!data.session)
            setMsg(
              "Account created. If email confirmation is on, check your inbox — then sign in.",
            );
        }
      } catch (e) {
        let m = e.message || "Something went wrong.";
        if (/path|invalid.*url|url.*invalid|fetch/i.test(m)) m += "  — Calling: " + URL_CLEAN;
        setErr(m);
      }
      setBusy(false);
    };
    return (
      <div className="min-h-screen flex items-center justify-center p-5 text-slate-100">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-6 justify-center">
            <div className="w-11 h-11 rounded-xl bg-amber-200 text-slate-900 flex items-center justify-center shadow-[0_0_30px_-5px_rgba(252,211,77,0.5)]">
              <I_Layers size={22} />
            </div>
            <span className="text-3xl text-slate-100" style={heading}>
              Estatebook
            </span>
          </div>
          <div className={`${glassDeep} rounded-2xl p-6 shadow-2xl`}>
            <div className="flex gap-1 mb-5 bg-white/[0.04] rounded-lg p-1 border border-white/[0.06]">
              {[
                ["signin", "Sign in"],
                ["signup", "Create account"],
              ].map(([k, l]) => (
                <button
                  key={k}
                  onClick={() => {
                    setMode(k);
                    setErr(null);
                    setMsg(null);
                  }}
                  className={`flex-1 py-1.5 rounded-md text-sm font-medium transition ${mode === k ? "bg-white/[0.08] text-slate-100" : "text-slate-400 hover:text-slate-200"}`}
                >
                  {l}
                </button>
              ))}
            </div>
            <div className="space-y-3">
              {mode === "signup" && (
                <div>
                  <label className={label}>Your name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className={input}
                    placeholder="e.g. Sujesh"
                  />
                </div>
              )}
              <div>
                <label className={label}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={input}
                  placeholder="you@example.com"
                  onKeyDown={(e) => e.key === "Enter" && submit()}
                />
              </div>
              <div>
                <label className={label}>Password</label>
                <input
                  type="password"
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  className={input}
                  placeholder={"\u2022".repeat(8)}
                  onKeyDown={(e) => e.key === "Enter" && submit()}
                />
              </div>
              {err && (
                <div className="text-xs text-rose-300 bg-rose-500/10 border border-rose-500/20 rounded-lg p-2.5 flex items-start gap-1.5">
                  <I_Alert size={14} className="shrink-0 mt-0.5" />
                  {err}
                </div>
              )}
              {msg && (
                <div className="text-xs text-emerald-200 bg-emerald-500/10 border border-emerald-500/20 rounded-lg p-2.5">
                  {msg}
                </div>
              )}
              <button
                onClick={submit}
                disabled={busy}
                className={`w-full ${btnP} py-2.5 disabled:opacity-50`}
              >
                {busy && <Spinner size={14} />} {mode === "signin" ? "Sign in" : "Create account"}
              </button>
            </div>
          </div>
          <p className="text-center text-[11px] text-slate-500 mt-4">
            Your team's data is private and protected by row-level security.
          </p>
          <p className="text-center text-[10px] text-slate-600 mt-2 px-4 leading-relaxed">
            Device info and approximate location are logged for security and audit. Your browser
            will ask permission for location — if you decline, only device info is recorded.
          </p>
        </div>
      </div>
    );
  };

export { AuthScreen };
